import React, {Component} from 'react';

import Title from './Title';
import Body from './Body';
import Container from './Container';
import ReturnItemLink from "js/components/pages/StatusPage/ItemStatusPage/ReturnItemLink";
import {inject} from "mobx-react";
import ErrorDisplay from "js/components/common/ErrorDisplay";
import Modal from "js/components/core/Modal";
import TransactionReview from "js/components/pages/StatusPage/ItemStatusPage/TransactionReview";

@inject('page')
export default class OrderReceivedModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDelivery: false,
      paying: false,
      modalLaunchReview: false,
      error: '',
    }
  }

  confirmAndPay = () => {
    setTimeout(() => {
      this.setState({paying:!this.state.paying})
    }, 5000);

    this.props.page.completeOrder();
    if (this.props.page.error !== ''){
      this.setState({modalOrderReceived: false});
      //open review modal
      this.openTransactionReviewModal();
    }
  }
  handleConfirmDelivery = () => {
    this.setState({confirmDelivery: !this.state.confirmDelivery});
  }

  toggle() {
    const { modalLaunchReview } = this.state;
    this.setState({
      modalLaunchReview: !modalLaunchReview
    });
  }

  closeReview = () => {
    this.setState({modalLaunchReview:false})
  }

  openTransactionReviewModal = () => {
    this.setState({modalLaunchReview: true})
  }

  render() {
    const page = this.props.page;
    const { modalLaunchReview } = this.state;
    const regex = /(<([^>]+)>)/gi;
    return (
      <>
        <Container>
          <Title style={{float: 'left'}}>Confirm delivery</Title><br/>
          <Body>
            <p style={{fontSize: '15px'}}>Kindly confirm that you have received your item(s) in good condition</p>


            {/*<span className="d-flex justify-content-center flex-md-row">*/}
            {/*  <div className="float-start w-[10%]">*/}
            {/*    <input  style={{fontSize: '14px', lineHeight: '21px', transform: 'scale(1.5)'}} type="checkbox"*/}
            {/*           defaultChecked={this.state.confirmDelivery} onChange={this.handleConfirmDelivery}/>*/}
            {/*  </div>*/}
            {/*  <div className="float-end">*/}
            {/*     <p  style={{fontSize: '14px', lineHeight: '21px', paddingLeft: '25px'}}>I received what I ordered in good condition. Please Proceed to pay the seller.</p>*/}
            {/*  </div>*/}
            {/*</span>*/}

            <button
              className="tw-mt-2 tw-w-full tw-h-[45px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white"
              disabled={this.state.paying} onClick={this.confirmAndPay}>
              {this.state.paying ? 'Releasing fund...':'Confirm and pay seller now'}
            </button>
            <ErrorDisplay style={{color:'black', fontWeight:500, fontStyle:'italics'}}>{page.error?page.error.replace(regex,""):''}</ErrorDisplay>
            <ReturnItemLink style={{marginTop:0}} onClick={page.returnOrder}>An issue with your order?</ReturnItemLink>

          </Body>

        </Container>

        <Modal showModal={modalLaunchReview} onCancel={this.closeReview} withCloseButton>
          <TransactionReview page={page} />
        </Modal>
      </>
    )

  }

}

